import { isNil } from "lodash";
import moment from "moment";

export function convertDateToIsoString(start: Date, end?: Date | null): { start: string; end: string } {
  const convertedStart = moment(start).utc().startOf("day");
  if (isNil(end)) {
    end = start;
  }
  const convertedEnd = moment(end).utc().startOf("day").add(1, "day").subtract(1, "second");

  return {
    start: convertedStart.toISOString(),
    end: convertedEnd.toISOString(),
  };
}